import React from "react"
import { Link, useLocation } from "react-router-dom"
import { useAuth } from '../../contexts/AuthContext'

import styles from "./AdminLayout.module.css"
import logo from "../../assets/images/rico_logo.jpeg"

const tabs = [
    { value: 'tickets', label: 'Tickets' },
    { value: 'flights', label: 'Flights' },
    { value: 'airports', label: 'Airports' },
    { value: 'promos', label: 'Promo Codes' },
    { value: 'bookings', label: 'Bookings' },
]

function AdminLayout({ children }) {
    const location = useLocation()
    const { logout } = useAuth()

    const queryParams = new URLSearchParams(location.search)
    const activeTab = queryParams.get("tab") || "tickets"


    return (
        <div className="container-fluid">
            <nav className={styles.adminHeader}>
                <Link to="/admin">
                    <img src={logo} alt="Company Logo" className={styles.logo} />
                </Link>
                <div>
                    <span className="material-symbols-outlined">notifications</span>&nbsp;&nbsp;
                    <span
                        className="material-symbols-outlined"
                        onClick={logout}
                        style={{ cursor: 'pointer' }}
                    >
                        logout
                    </span>
                </div>
            </nav>

            <ul className={`nav nav-tabs ${styles.adminNav}`}>
                {tabs.map((tab) => (
                    <li className="nav-item" key={tab.path}>
                        <Link
                            className={`nav-link ${activeTab === tab.value ? styles.activeTab : ''}`}
                            to={`/admin?tab=${tab.value}`}
                        >
                            {tab.label}
                        </Link>
                    </li>
                ))}
            </ul>

            <div>{children}</div>
        </div>
    )
}

export default AdminLayout
